export default class PopoverInfo {

    constructor($view) {
        this.$view = $view;
        this.$infoPopover = this.$view.find('.js-info-popover');
        this.bind();
    }

    bind() {
        let $this = this;

        this.$infoPopover.on('mouseover', function () {
            $(this).popover('show');
        });

        this.$infoPopover.on('inserted.bs.popover', function () {

            let $multiplePopovers = $this.$view.parents('.multiple-popover');

            if ($multiplePopovers.length > 0) {
                $this.closePopover($multiplePopovers[0])
                return;
            }

            let $window = $this.$view.parents('.card-body');
            $this.closePopover($window[0]);
        });
    }

    closePopover($window) {
        let $div = this.$view;
        let $this = this;
        $window.addEventListener('mouseover',function(e) {
            let $container = document.getElementsByClassName('info-popover')
            if ($container.length === 0) {
                return
            }

            let $popover = $container[0].closest('.popover')

            if (!$popover.contains(e.target) && !$div[0].contains(e.target) && $div[0] !== e.target && $popover !== e.target) {
                $this.$infoPopover.popover('hide');
                if ($popover.classList.contains('show')) {
                    $popover.remove();
                }
            }

        });
    }
}